import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { COMMON_IMPORTS } from '../../../../../Shared/common-imports';
import { AvSpinComponent } from '../../../../../Shared/Components/av-spin/av-spin.component';
import { AvPendingDirective } from '../../../../../Shared/Directives/av-pending.directive';
import { ReportExportPhase } from '../../../Types/report-export-phase.type';

@Component({
  selector: 'app-report-export-status',
  standalone: true,
  imports: [COMMON_IMPORTS, AvSpinComponent, AvPendingDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './report-export-status.component.html',
  styleUrl: './report-export-status.component.scss',
})
export class ReportExportStatusComponent {
  readonly phase = input.required<ReportExportPhase>();
  readonly rowCount = input<number | null>(null);
  readonly failureKey = input.required<string>();
  readonly downloading = input(false);

  readonly download = output<void>();
  readonly dismiss = output<void>();

  readonly busy = computed(() => {
    const phase = this.phase();
    return phase === 'starting' || phase === 'pending' || phase === 'processing';
  });

  readonly tone = computed<'info' | 'success' | 'error'>(() => {
    const phase = this.phase();
    if (phase === 'completed') return 'success';
    return phase === 'failed' ? 'error' : 'info';
  });

  readonly messageKey = computed<string>(() => {
    switch (this.phase()) {
      case 'processing':
        return 'app.reports.allDemands.export.processing';
      case 'completed':
        return 'app.reports.allDemands.export.completed';
      case 'failed':
        return this.failureKey();
      default:
        return 'app.reports.allDemands.export.pending';
    }
  });
}
